import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG, PRODUCTS } from "../data/site";
import { PageHero, CTASection } from "../components/Sections";
import { useLanguage, usePath } from "../i18n/LanguageContext";

const Products = () => {
  const { t } = useLanguage();
  const lp = usePath();

  return (
    <main data-testid="products-page">
      <PageHero
        overline={t.productsPage.overline}
        title={t.productsPage.title}
        intro={t.productsPage.intro}
        img={IMG.cleanPallets}
      />

      <section className="bg-[#FDFBF7] grain relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-24 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PRODUCTS.map((p) => {
            const tr = t.products[p.slug];
            return (
              <article
                key={p.slug}
                data-testid={`product-card-${p.slug}`}
                className="group bg-white border border-slate-200 overflow-hidden hover:border-amber-600 hover:-translate-y-1 transition-[border-color,transform,box-shadow] duration-200 hover:shadow-lg hover:shadow-slate-900/5 flex flex-col"
              >
                <div className="h-44 overflow-hidden">
                  <img
                    src={p.img}
                    alt={tr.name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h2 className="font-heading text-lg font-bold tracking-tight text-slate-900">{tr.name}</h2>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{tr.desc}</p>
                  <Link
                    to={lp(`/contact?service=${p.slug}`)}
                    data-testid={`product-card-${p.slug}-quote-button`}
                    className="mt-5 inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-bold bg-slate-950 text-white hover:bg-amber-600 transition-colors"
                  >
                    {t.home.requestQuote} <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <CTASection />
    </main>
  );
};

export default Products;
